'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateQuotes = undefined;
var _format = require('@marmalade/format');
var _format2 = _interopRequireDefault(_format);
var _reduxPromiseMiddleware = require('redux-promise-middleware');
var _constants = require('./constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var objectMap = function objectMap(obj, mapFn) {
  var result = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;
  try {
    for (var _iterator = Object.keys(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;
      result[key] = mapFn(obj[key], key);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return result;
};
var generateQuotes = exports.generateQuotes = function generateQuotes(_ref) {
  var premium = _ref.premium,
    premiumApr = _ref.premiumApr,
    premiumDeposit = _ref.premiumDeposit,
    premiumMonthly = _ref.premiumMonthly,
    premiumMonths = _ref.premiumMonths,
    premiumPayable = _ref.premiumPayable,
    quoteRef = _ref.quoteRef,
    premiumFacilityFee = _ref.premiumFacilityFee,
    premiumFirstInstalment = _ref.premiumFirstInstalment,
    adminFee = _ref.adminFee,
    underwriterId = _ref.underwriterId,
    ppmPremiums = _ref.ppmPremiums;
  return {
    quotes: {
      facilityFee: (0, _format2.default)('currency', premiumFacilityFee),
      firstInstalment: (0, _format2.default)('currency', premiumFirstInstalment),
      annual: (0, _format2.default)('currency', premium),
      apr: premiumApr,
      months: premiumMonths,
      deposit: (0, _format2.default)('currency', premiumDeposit),
      monthly: (0, _format2.default)('currency', premiumMonthly),
      totalPayable: (0, _format2.default)('currency', premiumPayable),
      adminFee: (0, _format2.default)('currency', adminFee),
      underwriterId: underwriterId
    },
    quoteRef: quoteRef,
    payg: ppmPremiums && ppmPremiums.newBusiness && ppmPremiums.newBusiness.rule === 'ACCEPT' ? {
      rule: ppmPremiums.newBusiness.rule,
      cost: Number(ppmPremiums.newBusiness.premiumIncludingIpt),
      topupOptions: {
        /*
          Map each mileage option to just the price with IPT.
           250: {
              "0-84": 410.98
              "85-89": 342.48
              "90-94": 308.22
              "95-100": 294.54
          }
        */
        250: objectMap(ppmPremiums[250], function (premium) {
          return Number(premium.premiumIncludingIpt);
        }),
        500: objectMap(ppmPremiums[500], function (premium) {
          return Number(premium.premiumIncludingIpt);
        }),
        750: objectMap(ppmPremiums[750], function (premium) {
          return Number(premium.premiumIncludingIpt);
        }),
        1000: objectMap(ppmPremiums[1000], function (premium) {
          return Number(premium.premiumIncludingIpt);
        })
      }
    } : {}
  };
};
var initialState = {
  fetching: false,
  requestError: false,
  quoteError: false,
  quoted: false,
  quoteRef: '',
  params: {
    age: '',
    postcode: '',
    regNo: '',
    abiCode: '',
    licenceType: '',
    value: ''
  },
  quotes: {},
  payg: {}
};
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  switch (action.type) {
    case _constants.actionTypes.QUOTE + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, {
          fetching: true,
          requestError: false,
          quoteError: false
        });
      }
    case _constants.actionTypes.QUOTE + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, initialState, {
          fetching: false,
          requestError: true
        });
      }
    case _constants.actionTypes.QUOTE + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        if (action.payload.data.status === 'SUCCESS') {
          var data = action.payload.data.quote;
          return Object.assign({
            fetching: false,
            requestError: false,
            quoteError: false,
            quoted: true,
            params: action.meta.params
          }, generateQuotes(data));
        }
        return Object.assign({}, state, {
          fetching: false,
          requestError: false,
          quoteError: true,
          quoted: false
        });
      }
    case _constants.actionTypes.CLEAR_QUOTES:
      {
        return initialState;
      }
    default:
      return state;
  }
};